<template>
    <template v-for="(item, index) in calculationList" :key="index">
        <PayrollProgressBox
            :showProgressStep="true"
            :processStatus="item.status"
            :current="item.currentStep"
            @close="closeThisPanner(item)"
            @closeConfirm="showConfirmClosePopup(item)"
            @go-back-to-list="goBackToList(item)"
            :statusConfig="statusConfig"
        >
            <template v-slot:subtitle >
                Payroll Name : {{ item.payrollName }}
            </template>
        </PayrollProgressBox>
    </template>

    <!-- 팝업____________________________________________________________________________________________________________________ -->
    <Teleport to="body">
        <div
            v-if="openCancelModal"
            class="fixed top-0 w-full h-full bg-black/50 z-[80] flex justify-center items-center"
        >
            <div
                class="bg-background-basic-1 pt-5 px-6 pb-6 flex flex-col justify-end items-start gap-6"
            >
                <div>
                    <Error
                        color="text-accent-red-1"
                        weight="SEPARATE"
                        :width="40"
                        :height="40"
                        :iconColor="'red'"
                    />
                    <div class="font-inter-heading-14">
                        Do you want to cancel the recalculation?
                    </div>
                </div>
                <div class="grid grid-cols-2 gap-1 w-full">
                    <DesignButton
                        @click-event="
                            () => {
                                openCancelModal = false;
                            }
                        "
                        btnType="QUATERNARY"
                        btnSize="MD"
                        btnText="No"
                        class="col-span-1 w-full"
                        :btnDisabled="false"
                    />
                    <DesignButton
                        @click-event="cancelThisRecalculation()"
                        btnType="PRIMARY"
                        btnSize="MD"
                        btnText="Yes"
                        class="col-span-1"
                        :btnDisabled="false"
                    />
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
import PayrollProgressBox from '@/components/design-system/design-payroll-notice-panel.vue';
import DesignButton from './design-button.vue';
import Error from './icon/error.vue';

export default {
    components: {
        PayrollProgressBox,
        DesignButton,
        Error,
    },
    data() {
        return {
            calculationList: [],
            openCancelModal: false,
            confirmPanel: {},
            statusConfig: {
                PROCESSING: {
                    heading: 'Recalculating Payroll...',
                    textWidth: 300,
                    closeAction: 'closeConfirm',
                },
                FINISHED: {
                    heading: 'Recalculating Completed',
                    textWidth: 264,
                    buttonAction: { text: 'View' },
                    closeAction: 'close',
                },
                FAIL: {
                    heading: 'Recalculating Failed',
                    textWidth: 239,
                    buttonAction: { text: 'Go back' },
                    closeAction: 'close',
                },
            },

            eventSource : null,
            isConnecting : false,
        };
    },
    mounted() {
        setTimeout(()=>{
            this.checkAndConnectSSE();
        }, 5000);
    },
    beforeUnmount() {
        if (this.eventSource) {
            this.eventSource.close();
            this.eventSource = null;
        }
        this.isConnecting = false;
    },
    methods: {
        checkAndConnectSSE() {
            const self = this;
            // ▼ 'this.yourVariableName'을 실제 사용하는 변수명으로 변경하세요.
            if (!window.connectAjaxRunning) {
                // 1. 조건이 true이면, SSE를 연결하고 함수를 종료합니다.
                // (더 이상 5초마다 재시도하지 않음)
                self.connectSSE();
            } else {
                // 2. 조건이 false이면, 5초 후에 이 함수를 다시 실행하여 재검사합니다.
                setTimeout(() => {
                    self.checkAndConnectSSE();
                }, 5000);
            }
        },
        showConfirmClosePopup(item) {
            this.confirmPanel = item;
            this.openCancelModal = true;
        },
        cancelThisRecalculation() {
            const self = this;
            let url = self.$api('uri', 'post-payroll-process-recalculation-cancel');
            url = url.replace('{payrollSeqValidMillis}', self.confirmPanel.payrollSeqValidMillis);

            self.$axios
                .post(url)
                .then((res) => {})
                .catch((err) => {
                    alert('failed to cancel');
                })
                .finally(() => {
                    self.openCancelModal = false;
                });
        },
        closeThisPanner(item) {
            const self = this;
            const closeIdx = self.calculationList.indexOf(item);
            if (closeIdx === -1) {
                return;
            }
            let url = self.$api('uri', 'delete-payroll-process-recalculation');
            url = url.replace('{payrollSeqValidMillis}', item.payrollSeqValidMillis);

            self.$axios
                .delete(url)
                .then((res) => {})
                .catch((err) => {});
        },
        goBackToList(item) {
            location.href = '/payroll/payroll_processing/';
        },
        setNoticePanel(jsonList) {
            const self = this;
            if (jsonList == '' || jsonList == undefined || jsonList == null) {
                self.calculationList = [];
                return;
            }

            let noticeList = JSON.parse(jsonList);
            self.calculationList = noticeList.map((p) => {
                const { payrollSeq, status, step, payrollName, payrollSeqValidMillis } = p;
                return {
                    payrollName,
                    status,
                    payrollSeq,
                    payrollSeqValidMillis,
                    currentStep: step,
                };
            });
        },
        connectSSE() {
            const self = this;
            if( self.eventSource || self.isConnecting ){
                console.warn("[SSE payroll-recalculation]: Already connected")
                return;
            }

            const url = this.$api('uri', 'get-stream-recalculation');
            this.isConnecting = true; 
            try{
                this.eventSource = new EventSource(url, {
                    withCredentials: true,
                    mode: 'cors',
                });

                // ?
                // 특별 공지
                this.eventSource.addEventListener('initialization', (event) => {
                    this.setNoticePanel(event.data);
                });

                // getReCalcList 이벤트
                this.eventSource.addEventListener('sseSubscribePanel', (event) => {
                    this.setNoticePanel(event.data);
                });

                this.eventSource.onopen = () => {
                    console.log("[SSE payroll-recalculation]: Connection opened");
                    this.isConnecting = false; // 연결 완료
                };

                // 에러 처리
                this.eventSource.onerror = (err) => {
                    console.info('[SSE payroll-recalculation] EventSource disconnected', err);
                    self.eventSource.close();
                    this.eventSource = null;
                    this.isConnecting = false;
                    setTimeout(self.connectSSE, 500); // 재연결
                };
            }catch(e){
                console.error("[SSE payroll-recalculation] Failed to connect:", e);
                this.eventSource = null;
                this.isConnecting = false;
                setTimeout(() => this.connectSSE(), 5000);
            }
            
        },
    },
};
</script>
